import { render } from "./MemberTypeSelector.vue?vue&type=template&id=2133abe6&scoped=true"
import script from "./MemberTypeSelector.vue?vue&type=script&lang=js"
export * from "./MemberTypeSelector.vue?vue&type=script&lang=js"

import "./MemberTypeSelector.vue?vue&type=style&index=0&id=2133abe6&lang=scss&scoped=true"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2133abe6"]])

export default __exports__